import React from 'react';

function Test2() {
  return <p>This is from Test 2</p>;
}

export default Test2;
